import { AddToCartData } from '../../types';
import { Activities, attraqtTracker } from './attraqtTracker';

function attraqtTrackerAddToCart(responseData: AddToCartData): void {
  if (!isProductAlreadyInCart(responseData)) {
    attraqtTracker({
      action: Activities.ADD_TO_CART,
      target: {
        product: responseData.entry.fhProductCode
      }
    });
  }
}

function isProductAlreadyInCart(data: AddToCartData): boolean {
  const currentEntry = data.entry;
  return !!data.entries.reduce((acc, alreadyInCartEntry) => {
    if (alreadyInCartEntry.fhProductCode === currentEntry.fhProductCode) {
      const res = acc + alreadyInCartEntry.productQuantity;
      return res;
    }
    return acc;
  }, -1);
}

export default attraqtTrackerAddToCart;
